import React, { useEffect, useRef } from 'react';

/**
 * Trustpilot TrustBox widget wrapper.
 * The bootstrap script is loaded once from public/index.html and exposes window.Trustpilot.
 * We call loadFromElement on our ref so the widget re-renders after React mounts / route changes.
 */
export const TrustpilotWidget = ({
  templateId = '56278e9abfbbba0bdcd568bc', // Review Collector
  businessUnitId = '6a474aa56513d6daba26501e',
  locale = 'sv-SE',
  height = '52px',
  width = '100%',
  token = '85b36611-405a-4a1f-bc20-b2d0214f3cc5',
  theme = 'light',
  className = '',
}) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);

  return (
    <div
      ref={ref}
      className={`trustpilot-widget ${className}`}
      data-locale={locale}
      data-template-id={templateId}
      data-businessunit-id={businessUnitId}
      data-style-height={height}
      data-style-width={width}
      data-theme={theme}
      data-token={token}
      data-testid="trustpilot-widget"
    >
      <a
        href="https://se.trustpilot.com/review/drivemaster.se"
        target="_blank"
        rel="noopener noreferrer"
      >
        Trustpilot
      </a>
    </div>
  );
};

export default TrustpilotWidget;
